import { Component } from '@angular/core';
import { Routes, RouterModule, Router, NavigationStart } from '@angular/router';

import { RoutesService } from './routes.service';
import { SecurityService } from '../Security/security.service';
import { EventsEmitterService } from '../Abstract/emitter.service';
import { LogService } from '../Abstract/log.service';



@Component({
  templateUrl: 'routing.component.html'
})
export class RoutingComponent {
  /*
  constructor() {
     // localStorage.clear();
     // this.logger.log("PeriId: " + localStorage.getItem("perId"));
   }
   */

  constructor(  private router: Router, 
                private routesService: RoutesService,
                private securityService: SecurityService,
                private eventsEmitterService: EventsEmitterService,
                private logger: LogService ) {


      this.logger.log("App Init");
      this.logger.log("langId: " + localStorage.getItem("langId"));
      this.logger.log("access_token: " + this.securityService.getFromStorage("access_token"));
      this.logger.log("refresh_token: " + this.securityService.getFromStorage("refresh_token"));
      let url = this.router.url;

      if(this.securityService.getFromStorage('access_token') != null && this.securityService.getFromStorage('refresh_token') != null){
          this.logger.log("already logged in");

          this.routesService.getRoutes(url);

          //this.router.navigateByUrl(val.url);
      
      } else {
          this.logger.log("redirect to login");
          this.securityService.goToLogin();
      }   

  }

}
